/* eslint-disable react/display-name */
import React from 'react';
import CreateAndUpload from '../form-renderer/form-usage';
import CRF from '../forms-scaffold/forms-home';
import Home from '../Home/home';
import Search from '../search/search';
import TemplateBuilder from '../template-builder/builder';
import UploadData from '../Upload/upload';
import SignIn from '../login/login';
import UploadProgress from '../UploadProgress/progress';
import { EditTable } from '../EditTable/EditTable';
import Geofence from '../geofence/index.tsx';

const routes = {
  '/upload/:id': () => <UploadData />,
  '/create/:id': () => <TemplateBuilder />,
  '/geofence/:customerId': ({ customerId }) => <Geofence customerId={customerId} />,
  '/data/:customerId/:templateId': ({ customerId, templateId }) => (
    <EditTable templateId={templateId} customerId={customerId} />
  ),
  '/template/:id': () => <CreateAndUpload />,
  '/': () => <SignIn />,
  '/home/': () => <Home />,
  '/uploads/:number': ({ number }) => <UploadProgress customerID={number} />,
  '/:number/?(:templateId/?)?': ({ number, templateId }) => (
    <Search customerID={number} templateId={templateId} />
  ),
};

export default routes;
